$(function () {
    superCookieInit();
    //chatTrack.Initialize();

    // CAEL menu removal hack
    //$('li a:contains("CAEL Partnership Program")').parent('li').css('display', 'none');
});



function superCookieInit() {
    try {
        var trackingData = superCookie.load();

        if (trackingData === null || trackingData.urls === null || typeof (trackingData.urls) === 'undefined') {
            trackingData.urls = [];
        }

        var pageTrack = new track();
        pageTrack.url = document.URL;
        pageTrack.code = $('input.scCode').length === 0 ? '' : $('input.scCode').val();

        setTimeout(function () {
            superCookie.SetDefaults(trackingData);
        }, 2000);

        if ((trackingData.urls.length === 0)) {
            trackingData.urls.push(pageTrack);
        } else {
            var lastVisitDate = new Date(trackingData.urls[trackingData.urls.length - 1].date);
            if ((trackingData.urls[trackingData.urls.length - 1].url !== document.URL) || (new Date() > lastVisitDate.setDate(lastVisitDate.getDate() + 2))) {
                trackingData.urls.push(pageTrack);
            }
        }

        while (trackingData.urls.length > superCookie.maxLength) {
            trackingData.urls.shift();
        }

        superCookie.save();

        if ($('input#CookieTrail').length === 0) {
            $('form').not('#searchForm').prepend($('<input type="hidden" id="CookieTrail" name="CookieTrail" />'));
        }
        $('input[id$="CookieTrail"]').val(JSON.stringify(superCookie.load()));
    } catch (err) {
        //console.log(err);
    }
};

function track(){
    this.url = '';
    this.date = new Date();
    this.code = '';
};

/************************************************************
superCookie tracks a users path through the site.
data is stored as json in the cookie
*************************************************************/
var superCookie = {
    maxLength: 20,

    data: {},

    load: function() {
        var the_cookie = superCookie.GetCookieByName('snhuSuperCookie');
        if (the_cookie != null) {
            the_cookie = the_cookie.split(';');
            if (the_cookie[0]) {
                this.data = JSON.parse(unescape(the_cookie[0]));
            }
        }
        return this.data;
    },

    save: function(expires, path) {
        var d = expires || new Date(2030, 2, 2);
        var p = path || '/';
        superCookie.WriteCookie('snhuSuperCookie', escape(JSON.stringify(this.data)), d.toUTCString(), p);
    },

    GetCookieByName: function(name) {
        var pos = document.cookie.indexOf(name + '=');
        if (pos == -1) {
            return null;
        } else {
            var pos2 = document.cookie.indexOf(';', pos);
            if (pos2 == -1) {
                return unescape(document.cookie.substring(pos + name.length + 1));
            } else {
                return unescape(document.cookie.substring(pos + name.length + 1, pos2));
            }
        }
    },

    WriteCookie: function(cookieName, cookieValue, cookieExpiresDate, path) {
        var cookieString = escape(cookieValue);
        var date = cookieExpiresDate;
        document.cookie = cookieName + '=' + cookieValue + ';expires=' + cookieExpiresDate + ';path=' + path + ';domain=.snhu.edu;';
    },

    SetDefaults: function(trackingData) {
        try {
            for (i = trackingData.urls.length - 1; i >= 0; i--) {
                if (trackingData.urls[i].code &&
                    trackingData.urls[i].code.toLowerCase() != 'msn' &&
                    trackingData.urls[i].code.toLowerCase() != 'msncle' &&
                    trackingData.urls[i].code.toLowerCase() != 'bsn' &&
                    trackingData.urls[i].code.toLowerCase() != 'rnmsn' &&
                    trackingData.urls[i].code.toLowerCase() != 'cwougn' &&
                    trackingData.urls[i].code.toLowerCase() != 'msnsgr') {
                    var prog = $('select#ProgramofInterest option[value^="' + trackingData.urls[i].code.toUpperCase() + '"]');
                    if (prog !== 'undefined' && prog.length > 0) {
                        if ($($(prog)[0]).attr('class')) {
                            $('select#AcademicLevel').val(($($(prog)[0]).attr('class').toLowerCase() == 'gr') ? 'graduate' : 'undergraduate');
                            //$('select#ProgramofInterest').val(trackingData.urls[i].code);                
                            $($(prog)[0]).attr('selected', 'selected');
                        }
                    }
                    break;
                }
            }
        } catch (err) {
            //console.log(err);
        }
    }

};

// code below handles asp.net updatepanel partial page loads
function pageLoad(sender, args) {
    superCookieInit();
};